import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  loadingContainer: {
    flex: 1
  }
})
